// this function set a listener that close the sidebar calculating the clic position when sidebar is open
const closeSidebar = () => {

  window.addEventListener('click' , (e) => {
    const sidebar = document.querySelector('#sidebar')

    if( !sidebar ) return console.warn('Sidebar doesn\'t exist')

    const isSidebarOpen = sidebar.classList.contains('sidebar-opened')

    if( !isSidebarOpen ) return
    const sidebarWidth = Number( window.getComputedStyle(sidebar).width.replace('px', '') )

    const clickPosition = window.innerWidth - e.clientX

    if( clickPosition > sidebarWidth ) {

      sidebar.classList.toggle('sidebar-opened')
    }
  })
}

closeSidebar()